export default {"src":"/_next/static/media/button-icon.b0013bc2.svg","height":10,"width":21};